import script from "./FbAd.vue?vue&type=script&setup=true&lang=js"
export * from "./FbAd.vue?vue&type=script&setup=true&lang=js"

import "./FbAd.vue?vue&type=style&index=0&id=493e07b6&lang=css"

const __exports__ = script;

export default __exports__